import React from 'react';
import { ResponsiveLayout } from '@/components/ResponsiveLayout';

export default function DatabaseSegmentationPage() {
  return (
    <ResponsiveLayout><div className="flex-1 min-h-screen bg-[#0A0A0B] text-[#F8F9FA]">
      
      <main className="flex-1 px-4 md:px-6 lg:px-8 py-6 md:py-8">
        <div className="mb-6">
          <h1 className="text-4xl font-bold font-heading text-[#F8F9FA] mb-2">
            Database Segmentation
          </h1>
          <p className="text-[#ADB5BD]">Internal Client CRM per IB</p>
        </div>
        <div className="border border-[#FFB703] bg-[#FFB703]/5 rounded-lg p-6 mb-6">
          <p className="text-[#FFB703]">🔒 Management & Admin Sales Only</p>
        </div>
        <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-6">
          <h3 className="text-xl font-semibold mb-4">Client Segments</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="border border-[#2A2A2E] rounded p-4">
              <p className="text-xs uppercase text-[#ADB5BD] mb-2">VIP Clients</p>
              <p className="text-3xl font-mono text-[#06D6A0]">45</p>
              <p className="text-xs text-[#6C757D] mt-2">Deposit {'>'} MYR 10k</p>
            </div>
            <div className="border border-[#2A2A2E] rounded p-4">
              <p className="text-xs uppercase text-[#ADB5BD] mb-2">Elite Clients</p>
              <p className="text-3xl font-mono text-[#FFB703]">12</p>
              <p className="text-xs text-[#6C757D] mt-2">Deposit {'>'} MYR 50k</p>
            </div>
            <div className="border border-[#2A2A2E] rounded p-4">
              <p className="text-xs uppercase text-[#ADB5BD] mb-2">Regular Clients</p>
              <p className="text-3xl font-mono text-[#F8F9FA]">316</p>
              <p className="text-xs text-[#6C757D] mt-2">Active traders</p>
            </div>
          </div>
        </div>
      </main>
    </div>
    </ResponsiveLayout>
  );
}
